// eslint-disable-next-line no-restricted-imports
import type { Logger } from '@glovo/logger'
import { getStdOutIntegration } from './integrations/std-out.node'

let loggerInstance: Logger<string>

// this workaround is needed as app config is not available build time
export const logger = new Proxy({} as Logger<string>, {
  get(_target: Logger<string>, prop: keyof Logger<string>) {
    if (!loggerInstance) {
      loggerInstance = getStdOutIntegration()
    }

    return loggerInstance[prop]
  },
})
